//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["tableData", "listKey", "pageName"],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    goDetails(item) {
      this.$emit("goDetails", item);
    },
    checkList(tab, check) {
      this.$emit("checkList", tab, check);
    }
  }
};
